interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohortPredicate: (experimentValue: string) => boolean;
	shouldProceedToStatsigEvaluation?: () => boolean;
}

export const NOT_ENROLLED_COHORT = 'not-enrolled';

const NON_VARIANT_COHORTS = new Set(['control', NOT_ENROLLED_COHORT]);

export const RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID = 'recent-downgrade-discount';
export const RECENT_DOWNGRADE_DISCOUNT_EXPERIMENT = 'recent-churn-discount-experiment';
export const ROVO_EXTENSION_CTA_TEMPLATE_ID = 'rovo-extension-install-cta-left-nav';

// Templates whose cohort checks move to inAppNarrowExposureExperiment + the choreo-disabled hook.
export const NARROW_EXPOSURE_EXPERIMENT_TEMPLATE_IDS: ReadonlySet<string> = new Set([
	RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID,
	ROVO_EXTENSION_CTA_TEMPLATE_ID,
]);

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		// TODO PO-10820: Remove this entry when the Confluence Rovo CTA experiment is cleaned up.
		// https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
		messageTemplateId: ROVO_EXTENSION_CTA_TEMPLATE_ID,
		statsigExperiment: 'rovo-ext_left_nav_rovo_extension_cta',
		statsigParameterName: 'cohort',
		statsigTestCohortPredicate: (experimentValue: string) =>
			!NON_VARIANT_COHORTS.has(experimentValue),
		shouldProceedToStatsigEvaluation: () => {
			if (typeof navigator === 'undefined') {
				return false;
			}
			return (navigator.userAgent || '').includes('Chrome');
		},
	},
];
